export default "__VITE_ASSET__DfjIQyVo__"